module.exports = __webpack_public_path__ + "img/45.6cad30e9.jpg";